<template>
  <nav>
    <v-app-bar
      app
      flat
      color="transparent"
      absolute
      max-width="1000px"
      class="ma-auto pr-5">
      <v-app-bar-nav-icon
        class="hidden-md-and-up"
        @click="drawer=!drawer" />
      <v-toolbar-title
        class="ma-0 pa-0">
        <v-btn
          x-large
          to="/"
          text
          color="transparent">
          <PxsLogo :width="($vuetify.breakpoint.mdAndUp)? 200 : 150" />
        </v-btn>
      </v-toolbar-title>
      <v-spacer />
      <template v-if="$vuetify.breakpoint.mdAndUp">
        <div
          v-for="(item, index) in items"
          :key="index">
          <v-btn
            v-if="item.desktopOnly"
            :to="item.slug"
            text
            width="100%">
            {{ item.name }}
          </v-btn>
        </div>
      </template>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      app
      floating
      disable-resize-watcher
      width="100%"
      height="100%"
      dark
      color="black">
      <v-list>
        <v-list-item>
          <v-btn
            text
            @click="drawer=!drawer">
            <v-icon>close</v-icon>
          </v-btn>
        </v-list-item>
        <v-list-item
          v-for="(item, index) in items"
          :key="index">
          <v-btn
            :to="item.slug"
            text
            width="100%">
            <strong class="headline font-weight-black text-none">
              {{ item.name }}
            </strong>
          </v-btn>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>
<script>
import PxsLogo from '@/components/icons/PxsLogo';

export default {
	name: "Navbar",

	components: { PxsLogo },

	data() {
		return {
			drawer: false,

			items: [
				{ "name": "Home", "slug": { path: '/' }, "desktopOnly": false },
				{ "name": "About Us", "slug": { path: '/about' }, "desktopOnly": true },
				{ "name": "Our Expertise", "slug": { path: '/our-expertise' }, "desktopOnly": true },
				{ "name": "Our Work", "slug": { path: '/our-work' }, "desktopOnly": true },
				{ "name": "Contact Us", "slug": { path: '/contact-us' }, "desktopOnly": true }
			]
		};
	}

};
</script>